<agpr-text-input #emailInput
    [id]="'emailInput.' + id"
    class="agpr-emailTextInput-input"
    [label]="label"
    [tooltip]="tooltip"
    [placeholder]="placeholder"
    [ariaLabel]="ariaLabel"
    [required]="required"
    [disabled]="disabled"
    [(ngModel)]="value"
    (ngModelChange)="onModelChange(value)"
    (blur)="assessEmail()"
    (keyup)="assessEmail()"
    maxLength="254"
    [icon]="emailIcon"
    [iconPopoverTemplate]="(assessmentMessages.length > 0 && !emailHasError) ? emailPopover : null"
    iconPopoverStyleClass="agpr-emailTextInput-hintsPopover"
    [iconPopoverText]="assessmentMessages.toString()"
>
</agpr-text-input>
<ng-template #emailPopover>
    <div class="agpr-emailTextInput-assessment-popover">
        <span class="agpr-emailTextInput-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
        <div class="agpr-emailTextInput-assessment-popover-content">
            <p
                *ngFor="let message of assessmentMessages"
                class="agpr-emailTextInput-assessment-popover-content-message"
            >
                {{ message }}
            </p>
        </div>
    </div>
</ng-template>
<span #ariaLiveRegion class="sr-only" role="region" aria-live="polite"></span>
<agpr-form-message *ngIf="emailHasError">
    {{ 'invalidEmailFormat' | localize }}
</agpr-form-message>
